<template>
  <div class="tour curated-tour" role="presentation">
    <header-mobile>
      <h3>{{ $t('message.curatedTour') }}</h3>
    </header-mobile>
    <main class="content" aria-label="Main content">
      <article
        v-if="description"
        class="description"
        aria-label="Description"
      >
        <h1>Tour the {{ $store.state.college.name }} Campus</h1>
        <span v-html="$tr(description)" />
      </article>
      <article
        v-else
        class="description"
        aria-label="Description"
      >
        <p>{{ $t("curatedTour.description1") }} {{ $t("curatedTour.description2") }}</p>
      </article>
      <ul class="categories" role="menu" aria-label="List of catigories">
        <li class="" v-for="tour in tourList" :key='tour.id' role="menuitem" :aria-label="$tr(tour.name)">
          <router-link :to="{ name: 'Tour', params: { id: tour.id } }" tag="a" class="blog-card alt main-border">
            <div class="description-card" role="presentation">
              <div
                class="recommended-hero"
                :style="{backgroundImage: 'url(' + tourImage(tour) + ')'}"
                @click="redirectTo(tour.id)"
                role="presentation"
              >
                <h1>{{ $tr(tour.name) }}</h1>
              </div>
              <p @click="redirectTo(tour.id)">{{ $tr(tour.information) }}</p>
              <audio-player v-for="audio in audioList(tour)" :key="audio.id" :audio="audio" />
            </div>
          </router-link>
        </li>
      </ul>
    </main>
  </div>
</template>

<script>
import HeaderMobile from '@/components/HeaderMobile'
import AudioPlayer from '@/components/AudioPlayer'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CuratedTour',
  components: {
    'header-mobile': HeaderMobile,
    'audio-player': AudioPlayer
  },
  created () {
    this.getTours()
  },
  computed: {
    ...mapState({
      description: state => state.college.settings.recommended_tour.description
    }),
    ...mapState('curated', {
      tourList: state => state.tourList
    })
  },
  methods: {
    redirectTo: function (id) {
      this.$router.push({ name: 'Tour', params: { id } })
    },
    tourImage: function (tour) {
      let images = tour.content.filter(item => item.type === 'image')

      if (images.length > 0) {
        return images[0].file.url
      } else {
        return require('@/assets/promo-students.jpg')
      }
    },
    audioList: function (tour) {
      return tour.content.filter(item => item.type === 'audio' && item.job.outputs.length > 0)
    },
    ...mapActions('curated', [
      'getTours'
    ])
  }
}
</script>
